import React from "react";

import { FormBuilder } from "shared/components";
import { IAPIState, IFormButtons, IAPIError } from "shared/types";
import { ICompany } from "Bands/types";
import { fields } from "./formData";
import { copy } from "shared/assets";

const billingCopy = copy.companyProperties;

interface BillingFormProps {
  apiStatus?: IAPIState;
  error?: boolean | string;
  defaultValues?: Record<string, any>;
  buttons?: IFormButtons;
  submitMode?: "isDirty";
  apiError?: IAPIError | null;
  handleSubmit: (company: ICompany) => void;
}

export const BillingForm: React.FC<BillingFormProps> = ({
  apiStatus,
  error,
  defaultValues,
  buttons,
  children,
  submitMode,
  handleSubmit,
  apiError,
}) => {
  const onSubmit = (company: ICompany) => {
    handleSubmit(company);
  };

  return (
    <FormBuilder
      fields={fields}
      defaultValues={defaultValues}
      buttons={buttons}
      onSubmit={onSubmit}
      isSubmitting={apiStatus === IAPIState.pending}
      submitMode={submitMode}
      apiErrorMessage={error}
      globalNote={billingCopy.termsOfUse}
      apiError={apiError}
    >
      {children}
    </FormBuilder>
  );
};
